import styled from 'styled-components';
import { Input } from '../Input';

interface HoverSelectProps<T = any> {
  label?: string;
  value: string;
  options: T[];
  onSelect: (item: any) => void;
  placeholder?: string;
  labelKey?: keyof T;
  valueKey?: keyof T;
}

const App = <T extends Record<string, any>>({
  label,
  value,
  options,
  onSelect,
  placeholder = '',
  labelKey = 'label',
  valueKey = 'value',
}: HoverSelectProps<T>) => {
  return (
    <Container>
      {label && <Label>{label}</Label>}
      <SelectBox>
        <Input value={value} placeholder={placeholder} readOnly />
        <Dropdown>
          {options.map((item, index) => (

            <DropdownItem key={index} onClick={() => onSelect(item)}>
              {item[labelKey] as string}
            </DropdownItem>
          ))}
        </Dropdown>
      </SelectBox>
    </Container>
  );
};

/* ---------------- Styled Components ---------------- */

const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Inter, sans-serif;
  overflow: visible; /* 防止下拉框被裁切 */
`;

const Label = styled.span`
  margin-right: 12px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
  color: #0e3a3f;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const SelectBox = styled.div`
  flex: 1;
  position: relative;

  &:hover > div:last-child {
    opacity: 1;
    visibility: visible;
    transform: translateY(6px) scale(1);
    pointer-events: auto;
  }
`;


export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% - 6px);   /* 和输入框保持固定间距 */
  left: 0;
  width: 100%;
  max-height: 260px;
  overflow-y: auto;
  z-index: 999;            /* 提高层级 */
  padding: 6px;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(31, 199, 212, 0.25);
  border-radius: 8px;
  box-shadow: 0 20px 44px -14px rgba(31, 199, 212, 0.35), 0 0 0 1px rgba(31, 199, 212, 0.04);
  word-break: break-all;
  box-sizing: border-box;

  opacity: 0;
  visibility: hidden;
  transform: translateY(0) scale(0.98);
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(31, 199, 212, 0.28);
    border-radius: 99px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(31, 199, 212, 0.5);
  }
`;

export const DropdownItem = styled.div`
  padding: 10px 14px;
  border-radius: 8px;
  line-height: 1.5;
  font-size: 14px;
  font-weight: 600;
  color: #123a3f;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: linear-gradient(135deg, rgba(31, 199, 212, 0.1), rgba(31, 199, 212, 0.2));
    color: #0a2a2e;
    transform: translateX(2px);
  }

  &:active {
    transform: translateX(2px) scale(0.99);
  }
`;

export default App;